import { Main } from '../Main/Main'

export const MainPage = () => <Main />
